import nadiaPic from "@/public/images/artists/nadia.png";
import { Artist } from "@/types/types";

export const nadia = {
  id: "131",
  name: "Nadia",
  image: nadiaPic,
  description: `Nadia's voice delivers intensity and passion in every performance, with a strong vibrato that enhances her emotional expression. Whether delivering soulful ballads or rhythmic, energetic tracks, Nadia's voice adds depth and vibrancy to any musical composition.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fnadia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Pop", "Ethereal", "Latin"],
      secondary: ["Alluring"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 57,
        high: 75,
      },
    },
  },
} as const satisfies Artist;
